import Layout from '../components/Layout';
import Container  from 'react-bootstrap/Container';
function Features() {
    return (
        <>
            <Layout>
            <Container>
                Features
            </Container>
            </Layout>
        </>
    );
}

export default Features;